import { Component, OnInit } from '@angular/core';
import { FooterService } from '../../../core/services/footer.service';
import { FooterData } from '../../../core/interfaces/footer.interface';

@Component({
  selector: 'app-footer-style-two',
  templateUrl: './footer-style-two.component.html',
  styleUrls: ['./footer-style-two.component.scss']
})
export class FooterStyleTwoComponent implements OnInit {
  footerData: FooterData | null = null;
  currentYear: number = new Date().getFullYear();

  constructor(private footerService: FooterService) { }

  ngOnInit(): void {
    this.loadFooterData();
  }

  private loadFooterData(): void {
    this.footerService.getFooterData().subscribe({
      next: (data) => {
        this.footerData = data;
      },
      error: (error) => {
        console.error('Error loading footer data:', error);
      }
    });
  }
}
